export const commonStyles = {
  dialogBtnStyle: {
    backgroundColor: "var(--color-accent-primary)",
    color: "#fff",
    "&:hover": {
      backgroundColor: "var(--color-accent-hover)",
    },
  },

  tapDeleteContainer: {
    backgroundColor: "var(--color-bg-elevated)",
    position: "absolute",
    top: "8px",
    right: "8px",
    cursor: "pointer",
    borderRadius: "20px",
    zIndex: 10,
  },

  tapDelete: {
    color: "var(--color-text-muted)",
    display: "block",
    "&:hover": {
      color: "var(--color-error)",
    },
  },
};
